import { Breadcrumb } from '../ui/semi';

interface PageHeaderProps {
  section: string;
  title: string;
  description: string;
}

export function PageHeader({ section, title, description }: PageHeaderProps) {
  return (
    <header className="page-header">
      <div className="visually-hidden">
        <h1>{title}</h1>
        <p>{description}</p>
      </div>
      <Breadcrumb routes={[section, title]} />
    </header>
  );
}
